import { memo, useMemo } from 'react'
import { Table, Space, Popconfirm } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { Game } from 'types/games'
import dayjs from 'dayjs'
import { gameTeamsLabel, modalTitle as formatModalTitle } from 'utils/modal-title'

type Props = {
    data: Game[]
    onEdit: (id: number) => void
    onMedia: (id: number) => void
    onDelete: (id: number) => void
    showRoster: (teamId: number, gameId: number) => void
    loading: boolean
}

export const GamesTable = memo((props: Props) => {
    const { data, onEdit, onMedia, onDelete, loading, showRoster } = props

    const columns: ColumnsType<Game> = useMemo(
        () => [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: 'League',
                key: 'league',
                render: (_, record) => record.teamHome.league.name,
            },
            {
                title: 'Round',
                key: 'round',
                dataIndex: 'round',
            },
            {
                title: 'Stage',
                key: 'stageId',
                render: (_, record) => record.stage?.name,
            },
            {
                title: 'Home team',
                key: 'teamHomeId',
                render: (_, record) => {
                    return (
                        <span>
                            <a onClick={() => showRoster(record.teamHome.team.id, record.id)}>Line-up</a> -{' '}
                            {record.teamHome.team.name}
                        </span>
                    )
                },
            },
            {
                title: 'Home score',
                dataIndex: 'homeScore',
                key: 'homeScore',
            },
            {
                title: 'Away score',
                dataIndex: 'awayScore',
                key: 'awayScore',
            },
            {
                title: 'Away team',
                key: 'teamHomeId',
                render: (_, record) => {
                    return (
                        <span>
                            <a onClick={() => showRoster(record.teamAway.team.id, record.id)}>Line-up</a> -{' '}
                            {record.teamAway.team.name}
                        </span>
                    )
                },
            },
            {
                title: 'Game time',
                key: 'gameTime',
                render: (_, record) =>
                    record.gameTime ? dayjs(record.gameTime * 1000).format('DD.MM.YYYY HH:mm') : '—',
            },
            {
                title: 'Action',
                key: 'action',
                render: (_, record) => (
                    <Space size='middle'>
                        <a onClick={() => onEdit(record.id)}>Edit</a>
                        <a onClick={() => onMedia(record.id)}>Media</a>
                        <Popconfirm
                            title={formatModalTitle(
                                `Delete game #${record.id}`,
                                gameTeamsLabel(record.teamHome.team.name, record.teamAway.team.name)
                            )}
                            description={'Are you sure to delete this game?'}
                            onConfirm={() => onDelete(record.id)}
                            okText={'Yes'}
                            cancelText={'No'}
                        >
                            <a href='#'>Delete</a>
                        </Popconfirm>
                    </Space>
                ),
            },
        ],
        [onDelete, onEdit, onMedia, showRoster]
    )

    return <Table loading={loading} columns={columns} dataSource={data} rowKey='id' pagination={false} />
})
